// Brand registry — the single source of truth for multi-brand behavior.
// All three brands are equal peers keyed by id; the active brand is selected by
// the build-time VITE_APP_BRAND env var. Consumers should read fields off BRAND
// or gate behavior with hasFeature(), never compare brand names inline.

import { CAPABILITY_KEYS, validateBrand } from "./contract";
import videobrief from "./brands/videobrief";
import condense from "./brands/condense";
import newzagent from "./brands/newzagent";

export const BRANDS = {
  videobrief,
  condense,
  newzagent,
};

const DEFAULT_BRAND_ID = "videobrief";
const requestedId = (import.meta.env.VITE_APP_BRAND || DEFAULT_BRAND_ID).toLowerCase();

export const BRAND = BRANDS[requestedId] || BRANDS[DEFAULT_BRAND_ID];
export const BRAND_ID = BRAND.id;

// Validate every brand once at load so a missing capability/field is a loud
// error during development/build rather than a silent fall-through at runtime.
if (import.meta.env.DEV) {
  for (const b of Object.values(BRANDS)) validateBrand(b);
}

export function hasFeature(key) {
  return Boolean(BRAND.features[key]);
}

export { CAPABILITY_KEYS };
